<template>
    <div ref="wrapper" class="tooltip-wrapper" v-bind:class="{ visible : stageHidden }">
        <div class="icon-tooltip" v-bind:class="{ active : show }" @click="handleVisibility"></div>
        <v-scale-transition origin="bottom right">
            <div class="tooltip" v-show="show">
                <div class="svg-wrapper">
                    <svg height="51" viewBox="0 0 254 51" width="254" xmlns="http://www.w3.org/2000/svg"><path d="m694.792245 100c18.079906 0 21.207755 10.82718 21.207755 25.548055 0 14.624765-3.812502 25.451945-21.793513 25.451945-18.078638 0-21.206487-10.82718-21.206487-25.451945 0-14.720875 3.811234-25.548055 21.792245-25.548055zm211.000643 0c18.080439 0 21.207112 10.826919 21.207112 25.547438 0 14.625643-3.811346 25.452562-21.792888 25.452562-18.079171 0-21.207112-10.826919-21.207112-25.452562 0-14.720519 3.811346-25.547438 21.792888-25.547438zm-43.069936 0c7.165955 0 12.508524 2.184605 14.226619 3.22947l-.572285 8.255418c-2.387-1.043633-8.497572-3.228238-13.368191-3.228238-8.688334 0-12.79219 4.748713-12.79219 13.960281v6.838443c0 10.446184 4.582 13.866638 10.501809 13.866638 3.437429 0 6.588715-1.044865 7.639144-1.520475v-16.181852h9.635948v21.215192c-2.190044 1.526636-8.968282 4.565123-17.848616 4.565123-17.281285 0-20.14519-11.585924-20.14519-25.357686 0-14.151265 4.200476-25.642314 22.722952-25.642314zm-73.744435 2c19.119816 0 23.021483 8.666599 23.021483 23.764232-.006328 15.941561-5.47094 24.235768-25.466511 24.235768h-14.533489v-48zm42.021483 0v48h-10v-48zm-90.017064 0c18.497483 0 22.756197 8.123728 23.017064 22.306096l-.005065 25.684231h-10.247254v-27.415617c-.010131-9.764433-5.552917-12.649269-13.062336-12.649269h-6.44189v40.074559h-10.243455v-48zm-46.384676 6.264243c-7.329588 0-11.140822 4.559072-11.140822 13.866972v6.743731c0 9.401546 3.607106 13.86574 10.944302 13.86574s11.140822-4.559072 11.140822-13.86574v-6.743731c0-9.402778-3.614713-13.866972-10.944302-13.866972zm211.000637.001032c-7.329805 0-11.142419 4.55773-11.142419 13.866638v6.742335c0 9.402551 3.616088 13.865406 10.945893 13.865406s11.141151-4.55773 11.141151-13.865406v-6.742335c0-9.402552-3.61482-13.866638-10.944625-13.866638zm-116.919048 1.656539h-6.437814v32.151536h3.706774c11.119056 0 15.510488-3.355164 15.510488-12.860856l.002531-6.61723c0-9.784987-5.270984-12.67345-12.781979-12.67345z" fill="#f3f4f6" transform="translate(-673 -100)"/></svg>
                </div>
                <div class="content">
                    <p class="big text-center">{{ $t('index.tooltip.txt1') }}<br>{{ $t('index.tooltip.txt2') }}<br>{{ $t('index.tooltip.txt3') }}</p>
                    <div class="contact">
                        <figure class="image-wrapper">
                            <picture>
                                <source srcset="/img/2021-05-21_ON_fallback.png"
                                        :data-srcset="require('~/assets/img/team/2020-11-17_ON_team_philipp-heine.jpg?size=35').src + ' 1x, ' + require('~/assets/img/team/2020-11-17_ON_team_philipp-heine.jpg?size=70').src + ' 2x'">
                                <img class="lazyload"
                                     alt="Ansprechpartner: Philipp Heine"
                                     width="650"
                                     height="650"
                                     :src="require('~/assets/img/team/2020-11-17_ON_team_philipp-heine.jpg?size=20').src"
                                     :data-src="require('~/assets/img/team/2020-11-17_ON_team_philipp-heine.jpg?size=35').src" />
                            </picture>
                        </figure>
                        <figure class="image-wrapper">
                            <picture>
                                <source srcset="/img/2021-05-21_ON_fallback.png"
                                        :data-srcset="require('~/assets/img/team/2020-11-17_ON_team_sven-liebchen.jpg?size=35').src + ' 1x, ' + require('~/assets/img/team/2020-11-17_ON_team_sven-liebchen.jpg?size=70').src + ' 2x'">
                                <img class="lazyload"
                                     alt="Ansprechpartner: Sven Liebchen"
                                     width="650"
                                     height="650"
                                     :src="require('~/assets/img/team/2020-11-17_ON_team_sven-liebchen.jpg?size=20').src"
                                     :data-src="require('~/assets/img/team/2020-11-17_ON_team_sven-liebchen.jpg?size=35').src" />
                            </picture>
                        </figure>
                        <figure class="image-wrapper">
                            <picture>
                                <source srcset="/img/2021-05-21_ON_fallback.png"
                                        :data-srcset="require('~/assets/img/team/2020-11-17_ON_team_robert-rentz.jpg?size=35').src + ' 1x, ' + require('~/assets/img/team/2020-11-17_ON_team_robert-rentz.jpg?size=70').src + ' 2x'">
                                <img class="lazyload"
                                     alt="Ansprechpartner: Robert Rentz"
                                     width="650"
                                     height="650"
                                     :src="require('~/assets/img/team/2020-11-17_ON_team_robert-rentz.jpg?size=20').src"
                                     :data-src="require('~/assets/img/team/2020-11-17_ON_team_robert-rentz.jpg?size=35').src" />
                            </picture>
                        </figure>
                    </div>
                    <div class="btn-wrapper text-center">
                        <a id="btn-tooltip" href="#" v-scroll-to="'#contact'" class="btn cta">{{ $t('index.tooltip.btn') }}</a>
                    </div>
                </div>
                <p class="text-center">Pfuelstr. 5 - Aufgang VI - 10997 Berlin</p>
                <p class="text-center"><a class="icon-phone_whiteblue on-underline" :href="'tel:' + $t('index.contact.phoneformatted')">{{ $t('index.contact.phone') }}</a></p>
                <p class="text-center"><a class="icon-pointer_whiteblue on-underline" href="https://www.google.com/maps/place/SkyGate+internetworking+GmbH/@52.5027645,13.4410892,15z/data=!4m5!3m4!1s0x0:0x82aa57a11d60f824!8m2!3d52.5027645!4d13.4410892?shorturl=1" rel="noopener" target="_blank">{{ $t('index.prefooter.route') }}</a></p>
            </div>
        </v-scale-transition>
    </div>
</template>

<script>
    export default {
        layout: 'contact',
        data () {
            return {
              show: true,
              stageHidden: false
            }
        },
        mounted() {
            let _scope = this;

            if(JSON.parse(sessionStorage.getItem('on-tooltip'))) {
                this.show = JSON.parse(sessionStorage.getItem('on-tooltip'));
            }

            // close contact on outside click
            window.addEventListener('click',function (e) {

                if(_scope.$refs.wrapper && _scope.show === true) {

                    // prevent close on usercentrics click
                    if(e.target.tagName !== 'BUTTON' && e.target !== _scope.$refs.wrapper && !_scope.$refs.wrapper.contains(e.target)) {
                        _scope.show = false;
                        sessionStorage.setItem('on-tooltip', _scope.show);
                    }
                }
            });

            this.onScroll();
            window.addEventListener('scroll', this.onScroll, {passive: true});
        },
      methods: {
        onScroll() {
          this.stageHidden = window.pageYOffset > (window.innerHeight - 1);
        },
        handleVisibility() {
          this.show = !this.show;
          sessionStorage.setItem('on-tooltip', this.show);
        }
      }
    }
</script>

<style lang="scss">

    .tooltip-wrapper {
        position: relative;
        z-index: 11;
        display: none;

        .icon-tooltip {
            position: fixed;
            right: 15px;
            bottom: 15px;
            cursor: pointer;
            @include transform(scale(1));

            &:before {
                width: 47px;
                height: 54px;
                @include transition(.4s ease all);
                background-image: url("data:image/svg+xml,%3Csvg height='54' viewBox='0 0 47 54' width='47' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m414.149823 418c18.780867 0 22.761637 11.463796 22.761637 27.050228 0 5.105574-.355107 9.773954-1.507853 13.738464l-.162178.536227 3.758571 10.127659-10.282617-.876027c-3.267646 2.195319-7.775224 3.423449-13.955745 3.423449-18.780868 0-22.761638-11.463796-22.761638-26.949772 0-15.586432 3.265662-27.050228 22.149823-27.050228zm11.424976 31.884771c-.558186-.630118-1.546611-.709636-2.20771-.177609-4.295795 3.457089-9.704982 4.45251-16.385847 2.954765-.842246-.188818-1.685615.308892-1.883717 1.111668-.198103.802776.324079 1.606622 1.166326 1.79544 7.600847 1.703991 14.028478.521152 19.124606-3.580014.661099-.532027.744527-1.474132.186342-2.10425zm-17.040815-14.231296c-1.441836 0-2.610675 1.162314-2.610675 2.5961s1.168839 2.596099 2.610675 2.596099 2.610675-1.162313 2.610675-2.596099-1.168839-2.5961-2.610675-2.5961zm9.398429-2.076879c-1.441836 0-2.610675 1.162313-2.610675 2.596099s1.168839 2.5961 2.610675 2.5961 2.610675-1.162314 2.610675-2.5961-1.168839-2.596099-2.610675-2.596099z' fill='%23c8e64b' transform='translate(-392 -418)'/%3E%3C/svg%3E");
            }

            &.active {
                @include animation(activateClick .4s);

                &:before {
                    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='47px' height='54px' viewBox='0 0 47 54' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3ECombined Shape%3C/title%3E%3Cg id='layout_NEU' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='2000--1600' transform='translate(-1518.000000, -911.000000)' fill='%23C8E64B' fill-rule='nonzero'%3E%3Cg id='contact-button' transform='translate(1518.000000, 493.000000)'%3E%3Cpath d='M22.1498225,418 C40.9306896,418 44.9114601,429.463796 44.9114601,445.050228 C44.9114601,450.387873 44.5233369,455.247677 43.2414286,459.324919 L43.2414286,459.324919 L47,469.452578 L36.7173829,468.576551 C33.4497368,470.77187 28.9421592,472 22.7616375,472 C3.98077045,472 -1.0658141e-14,460.536204 -1.0658141e-14,445.050228 C-1.0658141e-14,429.463796 3.26566198,418 22.1498225,418 Z M28.8384379,438.161562 C28.2526515,437.575776 27.302904,437.575776 26.7171176,438.161562 L26.7171176,438.161562 L22,442.879 L17.2828824,438.161562 L17.16896,438.058592 C16.5797992,437.578064 15.7107368,437.612387 15.1615621,438.161562 C14.5757756,438.747348 14.5757756,439.697096 15.1615621,440.282882 L15.1615621,440.282882 L19.879,445 L15.1615621,449.717118 L15.0585918,449.83104 C14.5780638,450.420201 14.6123873,451.289263 15.1615621,451.838438 C15.7473485,452.424224 16.697096,452.424224 17.2828824,451.838438 L17.2828824,451.838438 L22,447.121 L26.7171176,451.838438 L26.83104,451.941408 C27.4202008,452.421936 28.2892632,452.387613 28.8384379,451.838438 C29.4242244,451.252652 29.4242244,450.302904 28.8384379,449.717118 L28.8384379,449.717118 L24.121,445 L28.8384379,440.282882 L28.9414082,440.16896 C29.4219362,439.579799 29.3876127,438.710737 28.8384379,438.161562 Z' id='Combined-Shape'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
                }
            }
        }

        .tooltip {
            position: fixed;
            right: 15px;
            bottom: 90px;
            width: 305px;
            max-width: calc(100% - 30px);
            background: $blue;
            padding: 25px 20px;
            @include transition(.4s ease all);
            transform-origin: bottom right;
            @include border-radius(3px);
            @include box-shadow(0 0 20px 15px rgba(0,0,0,0.05));

            &:before {
                content: '';
                top: 0;
                left: 0;
                right: 0;
                z-index: -1;
                position: absolute;
                display: block;
                height: 150px;
                background: $midblue;
                -webkit-border-top-left-radius: 3px;
                -webkit-border-top-right-radius: 3px;
                -moz-border-radius-topleft: 3px;
                -moz-border-radius-topright: 3px;
                border-top-left-radius: 3px;
                border-top-right-radius: 3px;
            }

            .svg-wrapper {
                width: 164px;
                height: 33px;
                margin: 0 auto;

                svg {
                    width: 100%;
                    height: auto;
                }
            }

            .content {
                background: $white;
                margin-top: 20px;
                padding: 18px 12px;
                @include border-radius(3px);

                p.big {
                    font-size: 18px;
                    line-height: 24px;
                }

                .contact {
                    text-align: center;
                    margin-top: 10px;

                    .image-wrapper {
                        width: 35px;
                        height: 35px;
                        margin: 0 3px;

                        img {
                            @include border-radius(50%);
                            overflow: hidden;
                            border: thin solid rgba($midgrey, .3);
                        }
                    }
                }

                .btn {
                    font-size: 16px;
                    line-height: 22px;
                    margin-top: 15px;
                }

                & + p {
                    margin-top: 20px;
                }
            }

            > p {
                color: $white;
                font-size: 16px;
                line-height: 20px;

                & + p {
                    margin-top: 15px;
                }

                a {
                    color: $whiteblue;
                    font-size: 16px;
                    line-height: 20px;

                    &.icon-phone_whiteblue {
                        margin-left: 25px;

                        &:before {
                            width: 18px;
                            height: 18px;
                            left: -25px;
                            top: 0;
                            position: absolute;
                        }

                        &:after {
                            background: $whiteblue;
                        }
                    }

                    &.icon-pointer_whiteblue {
                        margin-left: 17px;

                        &:before {
                            width: 11px;
                            height: 17px;
                            left: -17px;
                            top: 1px;
                        }

                        &:after {
                            background: $whiteblue;
                        }
                    }
                }
            }
        }

        &.visible {
            display: block;

            .icon-tooltip {
                @include animation(activateClick .4s);
            }

            .tooltip {
                @include animation(expand .4s);
            }
        }
    }

    @include keyframes(activateClick) {
        0%   { @include transform(scale(1)); }
        50%  { @include transform(scale(1.3)); }
        100% { @include transform(scale(1)); }
    }

    @include keyframes(expand) {
        0%   { @include opacity(0); }
        100% { @include opacity(1); }
    }

    @media only screen and ($breakpoint375) {

        .tooltip-wrapper {

            .icon-tooltip {
                right: 30px;
                bottom: 20px;
            }

            .tooltip {
                right: 30px;
                bottom: 102px;
            }
        }
    }

    @media only screen and ($breakpoint768) {

        .tooltip-wrapper {

            .tooltip {
                right: 60px;
                bottom: 110px;
            }
        }
    }

    @media only screen and ($breakpoint1200) {

        .tooltip-wrapper {

            .icon-tooltip {
                right: 36px;
                bottom: 30px;
            }

            .tooltip {
                right: 100px;
                bottom: 100px;
            }
        }
    }

    @media only screen and ($breakpoint1700) {

        .tooltip-wrapper {

            .icon-tooltip {
                right: 40px;
                bottom: 25px;
            }

            .tooltip {
                right: 100px;
                bottom: 100px;
            }
        }
    }
</style>